import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2293eee0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-wrap" }
const _hoisted_2 = {
  class: "device-list-wrap",
  id: "device-list-wrap"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "right-wrap" }
const _hoisted_5 = { class: "sn" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "description-inner" }, " 如当前页面未找到要申请铭牌三证补办的设备 可能原因：当前登录用户非设备拥有人或设备型号不支持申请铭牌补办。 ")
], -1))
const _hoisted_7 = {
  key: 1,
  class: "no-device-wrap"
}
const _hoisted_8 = { class: "no-device-inner" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-tip" }, "暂无符合申请铭牌三证补办条件的设备", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reason" }, " 可能原因：当前登录用户非设备拥有人或设备型号不支持申请铭牌补办。 ", -1))
const _hoisted_11 = { class: "bottom-wrap xag-page__footer" }

import { RadioGroup, Radio, Button, Icon, PullRefresh, Loading } from 'vant'
import Device from '@/assets/nameplate-reissue/device.svg'
import { ref, withDefaults, computed, onMounted } from 'vue'

export interface DeviceListItemType {
  sn: string
  productText: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'device-list',
  props: {
    data: null,
    refreshing: { type: Boolean },
    checked: null
  },
  emits: ["onRefresh", "update:refreshing", "confirm", "update:checked"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'onRefresh'): void
  (event: 'update:refreshing', value: boolean): void
  (event: 'confirm', value: string): void
  (event: 'update:checked', value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { data: Array<DeviceListItemType>, refreshing: boolean, checked: string };





let data = computed(() => {
  return props.data
})

let checked = computed({
  get() {
    return props.checked
  },
  set(value) {
    emit('update:checked', value)
  },
})
let refreshing = computed({
  get() {
    return props.refreshing
  },
  set(value) {
    emit('update:refreshing', value)
  },
})
function clickHandle(item: DeviceListItemType) {
  checked.value = item.sn
}
function onRefresh() {
  emit('onRefresh')
}
function confirmHandle() {
  emit('confirm', checked.value)
}

let isDeciceListWrapTop = ref(true)

onMounted(() => {
  // let deciceListWrap = document.getElementById('device-list-wrap')
  // deciceListWrap.addEventListener('scroll', () => {
  //   isDeciceListWrapTop.value = deciceListWrap.scrollTop === 0
  // })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(PullRefresh), {
        modelValue: _unref(refreshing),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(refreshing) ? (refreshing).value = $event : refreshing = $event)),
        onRefresh: onRefresh,
        class: "pull-refresh-wrap",
        disabled: true
      }, {
        default: _withCtx(() => [
          (_unref(data).length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["device-list-item", { 'active-list-item': _unref(checked) === item.sn }]),
                      key: index,
                      onClick: ($event: any) => (clickHandle(item))
                    }, [
                      _createElementVNode("div", null, [
                        _createVNode(_unref(RadioGroup), {
                          modelValue: _unref(checked),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checked) ? (checked).value = $event : checked = $event)),
                          direction: "horizontal",
                          "checked-color": "rgba(0, 195, 120, 1)",
                          class: "radio-group"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Radio), {
                              name: item.sn
                            }, null, 8, ["name"])
                          ]),
                          _: 2
                        }, 1032, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", null, _toDisplayString(item.productText), 1),
                        _createElementVNode("span", _hoisted_5, "序列号: " + _toDisplayString(item.sn), 1)
                      ])
                    ], 10, _hoisted_3))
                  }), 128))
                ]),
                _hoisted_6
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_unref(refreshing) === false)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_unref(Icon), {
                          name: _unref(Device),
                          size: "80"
                        }, null, 8, ["name"]),
                        _hoisted_9,
                        _hoisted_10
                      ], 64))
                    : (_openBlock(), _createBlock(_unref(Loading), { key: 1 }))
                ])
              ]))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_unref(Button), {
        class: "ok-button",
        color: "rgba(0, 195, 120, 1)",
        onClick: confirmHandle
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})